const accountCheckbox = document.getElementById('account_checkbox');
const accountDesktopNav = document.getElementById('desktop-account-nav');
const accountDesktopTrigger = document.getElementById(
  'desktop-account-trigger'
);

const listenOnce = function (el, type, callback) {
  const tempCallback = function (event) {
    callback(event);

    el.removeEventListener(type, tempCallback);
  };

  el.addEventListener(type, tempCallback);
};

if (accountCheckbox) {
  const isMobile = window.matchMedia('(max-width: 768px)');

  accountCheckbox.addEventListener('change', function () {
    if (!accountCheckbox.checked || isMobile.matches) {
      return;
    }

    setTimeout(function () {
      listenOnce(document.body, 'click', function (event) {
        if (
          !accountDesktopNav.contains(event.target) &&
          !accountDesktopTrigger.contains(event.target)
        ) {
          accountCheckbox.checked = false;
        }
      });
    }, 0);
  });
}
